import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';


export const generateWarrantyErrorRateReport =
  (parameters = {}) =>
    (dispatch) => {
      return dispatch(
        apiActionCreator({
          'endpoint': `/warranties/error-rate/report${getUrlParameters(
            parameters
          )}`,
          'authenticated': true,
          'types': [
            ActionTypes.FETCHING_WARRANTY_ERROR_RATE_REPORT,
            ActionTypes.FETCHED_WARRANTY_ERROR_RATE_REPORT,
            [
              ActionTypes.FETCHED_WARRANTY_ERROR_RATE_REPORT_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],
          'microservice': 'part',
          'method': 'GET',
        })
      );
    };
